export default __webpack_public_path__ + "static/media/battery-25.69285fbe.svg";